module.exports = __webpack_public_path__ + "media/src/images/buttons/facebook-messenger-ac7ce679973b5da3d18576981f79d2b2.svg";